import { createSelector } from "reselect";

export const selectTrafficTemplateManager = state =>
  state.trafficTemplateManager;

export const selectIsTrafficTemplateDialogOpen = createSelector(
  selectTrafficTemplateManager,
  trafficTemplate => trafficTemplate.openTemplateDialog
);
